<template>
  <el-dialog
    v-if="visible"
    :custom-class="$style.dialog"
    :visible="true"
    title="添加银行卡"
    @close="close"
  >
    <Loading :loading="loading" text="正在添加...">
      <Item title="真实姓名" required>
        <el-input
          v-if="userInfo.username"
          v-model="userInfo.username"
          disabled
        />
        <span v-else :class="$style.real_name">
          您还未进行实名认证，请
          <span :class="$style.certify" @click="toCertify">前往认证</span>
        </span>
      </Item>

      <Item title="银行卡账号" required>
        <el-input
          v-model.trim="bankcard"
          @input="onBankcardInput"
          @change="onBankcardChange"
        />
      </Item>

      <Item title="确认账号" required>
        <el-input v-model.trim="confirmBankcard" />
      </Item>

      <Item title="银行名称">
        <el-input
          v-model="bankName"
          placeholder="请先输入银行卡账号"
          disabled
        />
      </Item>

      <Item title="开户地区" required>
        <el-select
          v-model="province"
          placeholder="请选择省份"
          value-key="id"
          @change="handleProvinceChange"
        >
          <el-option
            v-for="item in provinceList"
            :key="item.id"
            :label="item.label"
            :value="item.label"
          >
          </el-option>
        </el-select>
        <el-select
          v-show="cityList.length > 0"
          v-model="city"
          placeholder="请选择城市"
          @change="handleCityChange"
        >
          <el-option
            v-for="item in cityList"
            :key="item.id"
            :label="item.label"
            :value="item.label"
          >
          </el-option>
        </el-select>
        <el-select
          v-show="areasList.length > 0"
          v-model="areas"
          placeholder="请选择区域"
        >
          <el-option
            v-for="(item, index) in areasList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </Item>

      <Item title="开户支行" required>
        <el-input v-model.trim="branch" />
      </Item>

      <Row :class="$style.actions">
        <Button type="primary" @click="confirm">确认</Button>
        <Button type="primary2" @click="close">取消</Button>
      </Row>
    </Loading>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";

import { getAddress, getBankName, createBankCard } from "@server";

export default {
  name: "BankCardPopup",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      provinceList: [], // 中国省市列表
      cityList: [], // 对应省市的城市列表
      areasList: [], // 对应城市的县区列表
      province: "", // 省 - 市
      city: "", // 市 - 县
      areas: "", // 县 - 区

      bankcard: "",
      confirmBankcard: "",
      bankName: "",

      branch: "", // 支行
    };
  },
  computed: {
    ...mapState("user", ["userInfo"]),
  },
  methods: {
    async getAddress() {
      const res = await getAddress();
      const { code, data, message } = res;

      if (code === 200) {
        this.countryList = data.countryList;

        this.provinceList = data.distList;
      } else {
        this.$message({ message, type: "warning" });
      }
    },

    toCertify() {
      this.$router.push("/user/safe-name");
    },

    onBankcardInput(val) {
      const res = val.match(/\d*/g) || [""];
      this.bankcard = res[0];
    },

    async onBankcardChange(val) {
      if (this.bankcard.length < 16) return;
      const res = await getBankName(this.bankcard);

      if (res.code === 200) {
        this.bankName = res.data || "";
      } else {
        this.$message({ message: res.message, type: "warning" });
      }
    },

    setIndexToId(arr) {
      return arr.map((item, index) => ({ ...item, id: index }));
    },

    //选择省
    handleProvinceChange(value) {
      this.province = value;
      this.city = "";
      const cityList = this.provinceList.find(
        (item) => item.value === value
      )?.children;
      this.cityList = this.setIndexToId(cityList);
    },
    handleCityChange(value) {
      this.city = value;
      const districtList = this.cityList.find(
        (item) => item.value === value
      )?.children;
      this.areasList = this.setIndexToId(districtList);
    },

    checkConfirm() {
      if (!this.userInfo.username) {
        this.$message({ message: "请先进行实名认证!", type: "warning" });
        return false;
      }

      if (!this.bankcard) {
        this.$message({ message: "请输入银行卡账号!", type: "warning" });
        return false;
      }

      if (!this.confirmBankcard) {
        this.$message({ message: "请输入确认账号!", type: "warning" });
        return false;
      }

      if (this.cardNumber !== this.confirmCardNumber) {
        this.$message({
          message: "两次银行卡账号输入不一致！",
          type: "warning",
        });
        return false;
      }

      if (this.bankName === "" || this.bankName === "银行卡不存在") {
        this.$message({ message: "银行卡不存在!", type: "warning" });
        return false;
      }

      if (!this.province || !this.city || !this.areas) {
        this.$message({ message: "请选择开户地区!", type: "warning" });
        return false;
      }

      if (!this.branch) {
        this.$message({ message: "请输入开户支行!", type: "warning" });
        return false;
      }

      return true;
    },

    async confirm() {
      if (!this.checkConfirm()) return;

      this.loading = true;
      const data = {
        cardNumber: this.bankcard,
        confirmCardNumber: this.confirmBankcard,
        bankName: this.bankName,
        province: this.province,
        city: this.city,
        areas: this.areas,
        branch: this.branch,
      };
      const res = await createBankCard(data);

      if (res.code === 200) {
        this.$message({ message: "添加成功", type: "warning" });
        this.$emit("success");
        this.close();
      }
      this.loading = true;
    },

    close() {
      this.$emit("close");
    },
  },
  created() {
    this.getAddress();
  },
};
</script>

<style lang="scss" module scoped>
::v-deep .dialog {
  width: 520px;
  font-size: rem(14);

  :global {
    .gl-item {
      margin-left: 50px;

      .gl-item__left {
        width: 70px;
      }
    }

    .el-input {
      width: 210px;
    }

    .el-select {
      .el-input {
        width: 100px;
        margin-right: 10px;
      }
    }
  }

  .real_name {
    font-size: rem(14);

    .certify {
      color: $theme-blue-color;
      cursor: pointer;
    }
  }

  .actions {
    justify-content: center;
    gap: 50px;
  }
}
</style>